import { useNavigate } from 'react-router-dom';
import '../css/footer.css';
import logoOriz from '../images/logo_oriz_white_500.png';
import social from '../images/social_500.png';

const Footer = () => {

  //----- LINKS -----//

  const navigate = useNavigate();

  const goToHomepage = () => {
    navigate('/homepage');
  }

  const goToProfile = () => {
    navigate('/userProfile');
  }

  const goToMyRoba = () => {
    navigate('/myRoba');
  }

  const goToMyExchanges = () => {
    navigate('myExchanges');
  }

  //-----//

  return (
    <div className="footer">
      <div className="footer-section">
        <ul>
          <li>Arredamento</li>
          <li>Soprammobili</li>
          <li>Elettrodomestici</li>
          <li>Tecnologia</li>
          <li>Giochi</li>
          <li>Vestiti</li>
          <li>Libri</li>
          <li>Attrezzi sportivi</li>
          <li>Attrezzi da lavoro</li>
          <li>Altro</li>
        </ul>
      </div>
      <hr />
      <div className="footer-section">
        <ul>
          <li onClick={goToHomepage}>Home</li>
          <li onClick={goToProfile}>Il mio profilo</li>
          <li onClick={goToMyRoba}>La mia ROBA</li>
          <li onClick={goToMyExchanges}>I miei scambi</li>
          <li>Il mio punteggio</li>
          <li>Assistenza</li>
        </ul>
      </div>
      <hr />
      <div className="footer-section">
        <ul>
          <li>Cookie</li>
          <li>Gestione dei cookie</li>
          <li>Annullamento dell'iscrizione</li>
          <li>Termini e condizioni</li>
          <li>Informativa sulla privacy</li>
          <li>Assistenza</li>
        </ul>
      </div>
      <hr />
      <div className="footer-section">
        <img id="footer-logo" src={logoOriz} />
        <ul>
          <li>Contenuti protetti © Roba S.r.l.</li>
          <li>Tutti i diritti riservati</li>
        </ul>
        <img id="social" src={social} />
      </div>
    </div>
  )
}

export default Footer;
